import { Box, Flex, Skeleton, Stack } from '@mantine/core'
import Image from 'next/image'

import { CHART_HEIGHT } from '@/app/[locale]/price/[slug]/_components/CoinLineChart/utils'
import placeholderChart from '@/assets/images/placeholder-price-chart.webp'

export default function ChartSkeleton() {
  return (
    <Box flex={1}>
      <Flex align={'center'} mb={'sm'}>
        <Skeleton circle h={32} w={32} style={{ backgroundColor: 'var(--bg-surface-secondary)' }} />
        <Skeleton
          h={24}
          w={120}
          mx={8}
          style={{ backgroundColor: 'var(--bg-surface-secondary)', borderRadius: 4 }}
        />
        <Skeleton
          h={24}
          w={80}
          flex={1}
          style={{ backgroundColor: 'var(--bg-surface-secondary)', borderRadius: 4 }}
        />
        <Skeleton
          circle
          h={32}
          w={32}
          ml={8}
          style={{ backgroundColor: 'var(--bg-surface-secondary)' }}
        />
        <Skeleton
          circle
          h={32}
          w={32}
          ml={8}
          style={{ backgroundColor: 'var(--bg-surface-secondary)' }}
        />
      </Flex>

      <Stack gap={12} mb={12}>
        <Flex h={40} justify={'flex-start'} align={'center'} gap={8}>
          <Skeleton
            h={36}
            w={200}
            style={{ backgroundColor: 'var(--bg-surface-secondary)', borderRadius: 4 }}
          />
          <Skeleton
            h={36}
            w={80}
            style={{ backgroundColor: 'var(--bg-surface-secondary)', borderRadius: 4 }}
          />
        </Flex>
      </Stack>

      <Box
        h={CHART_HEIGHT}
        w={'100%'}
        pos="relative"
        style={{ borderRadius: 8, overflow: 'hidden' }}
      >
        <Image
          src={placeholderChart}
          alt="Loading chart"
          fill
          style={{ objectFit: 'contain' }}
          priority
        />
      </Box>

      <Flex align={'center'} h={36} mt={12} gap={8}>
        <Skeleton
          h={32}
          w={'100%'}
          style={{ backgroundColor: 'var(--bg-surface-secondary)', borderRadius: 4 }}
        />
      </Flex>
    </Box>
  )
}
